module.exports = __webpack_public_path__ + "img/helal-pro.7cbe53d1.jpg";